import { useMutation } from '@tanstack/react-query';
import { FullDetailedMealPlan } from '@web-app/server/api/types';

const sendDetailedMealPlan = async (
  payload: FullDetailedMealPlan,
): Promise<void> => {
  const res = await fetch('/api/meal-plan/send-detailed-meal-plan', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    // soft fail.
    return Promise.reject('Failed to send meal plan');
  }

  return res.json();
};

export const useSendDetailedMealPlan = () =>
  useMutation({
    mutationFn: (payload: FullDetailedMealPlan) =>
      sendDetailedMealPlan(payload),
  });
